import React from 'react'
import { Icon } from '@iconify/react'
import {
  Typography,
  FormControl,
  Select,
  MenuItem,
  Input,
  withStyles,
} from '@material-ui/core'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import { useSelector } from 'react-redux'
import styles from '../../styles'
import { BackButton } from '..'
import { CoreButton, CoreTextField } from 'src/components/core'

const DEFAULT_SHARE_URL = process.env.REACT_APP_VIEW_URL?.replace(/\/$/, '') || 'https://share.minicoursegenerator.com'
const DEFAULT_SHARE_DOMAIN = process.env.REACT_APP_VIEW_URL?.replace(/^https?:\/\//, '').replace(/\/$/, '') || 'share.minicoursegenerator.com'

const StepOne = props => {
  const {
    entity,
    videoUrl,
    handleNext,
    handleBack,
    classes,
    collectionId,
  } = props
  /*const collectionName = entity.collectionName
    .replaceAll(/\?.*$/g, '')
    .replaceAll(' ', '-')*/

  const customDomain = useSelector(state => state.domain.list)

  const customDomainList = customDomain && customDomain.results
  const collectionDomain =
    customDomainList &&
    customDomainList.filter(item =>
      item.defaultCollectionDto != null &&
      item.defaultCollectionDto.id == collectionId
        ? collectionId
        : entity.id,
    )

  const [domains, setDomains] = React.useState(collectionDomain)

  const hasVerifiedDomain =
    domains && domains.find(x => x.verificationStatus == 1)

  const [copiedShareCode, setCopiedShareCode] = React.useState(false)

  const onClickShareCode = () => {
    setCopiedShareCode(true)
    setTimeout(() => {
      setCopiedShareCode(false)
    }, 500)
  }
  const domain =
    entity && entity.customDomainDtos
      ? entity.customDomainDtos.length == 0 ||
        entity.customDomainDtos[0].verificationStatus != 1
        ? DEFAULT_SHARE_URL
        : entity.customDomainDtos[0].domain
      : DEFAULT_SHARE_URL

  const [domainName, setDomainName] = React.useState(domain)

  const handleDomain = e => {
    setDomainName(e.target.value)
  }
  return (
    <div className={classes.stepOne_main}>
      <div className={classes.stepOne_main_title}>
        <Icon
          icon="octicon:play-24"
          width="20px"
          height="20px"
          style={{ color: '#FD2222', marginRight: '5px' }}
        ></Icon>
        <Typography fontSize={'14px'} fontWeight={400}>
          Watch the video guide and add this URL on the Webhook page as shown.
        </Typography>
      </div>
      <iframe
        width="440"
        height="235"
        src={videoUrl}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className={classes.iframeStyle}
      ></iframe>
      {hasVerifiedDomain && (
        <div>
          <FormControl variant="outlined" className={classes.listGroup}>
            <Select
              variant="outlined"
              className={classes.select}
              inputProps={{
                className: classes.inputField,
              }}
              fullWidth
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              label="Choose your domain"
              value={domainName}
              disabled={false}
              input={<Input id="select-input" name="select-input" />}
              onChange={handleDomain}
            >
              <MenuItem value={DEFAULT_SHARE_URL}>
                {DEFAULT_SHARE_DOMAIN}
              </MenuItem>
              {domains &&
                domains
                  .filter(x => x.verificationStatus == 1)
                  .map(value => {
                    return (
                      <MenuItem
                        value={'https://' + value.domain}
                        key={value.domain}
                      >
                        {value.domain}
                      </MenuItem>
                    )
                  })}
            </Select>
          </FormControl>
        </div>
      )}
      <CoreTextField
        value={
          hasVerifiedDomain
            ? domainName + '/payment-success'
            : domain + '/payment-success'
        }
        style={{
          width: '440px',
        }}
      />
      <CopyToClipboard
        text={
          hasVerifiedDomain
            ? domainName + '/payment-success'
            : domain + '/payment-success'
        }
      >
        <CoreButton
          color="primary"
          variant="outlined"
          size="medium"
          onClick={onClickShareCode}
          style={{
            width: '440px',
          }}
        >
          {copiedShareCode ? 'Copied!' : 'Copy to Clipboard'}
        </CoreButton>
      </CopyToClipboard>
      <div className={classes.stepOne_main_buttons}>
        <BackButton handleBack={handleBack} />
        <CoreButton
          variant="contained"
          color="success"
          size="medium"
          onClick={handleNext}
        >
          Continue
        </CoreButton>
      </div>
    </div>
  )
}

export default withStyles(styles)(StepOne)
